import { render } from "./App.vue?vue&type=template&id=74dd22de"
const script = {}

import exportComponent from "D:\\work\\code\\jingcisi\\wx\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__